<template>
  <div class="auth-page auth-page--login">
    <div class="auth-page__inner">
      <div class="auth-page__title">{{ $t("otp.registration.title") }}</div>
      <div class="auth-page__sub-title">
        {{ $t("otp.registration.sub_title") }}
      </div>
      <div class="auth-page__fields">
        <div class="auth-page__field">
          <text-input
            :title="$t('otp.input_title')"
            :mask="'####'"
            v-model="otpCode"
            :errors="v$.otpCode.$errors"
            ref="otpInput"
            autocomplete="one-time-code"
            @enterPressed="verifyUser"
          ></text-input>
        </div>
      </div>
      <div class="auth-page__actions">
        <primary-button
          class="auth-page__action auth-page__action--half"
          :text="$t('otp.actions.finish_registration')"
          @click="verifyUser"
        ></primary-button>
        <transparent-button
          class="auth-page__action auth-page__action--half"
          :text="$t('otp.actions.back_to_login')"
        ></transparent-button>
      </div>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/buttons/PrimaryButton";
import TransparentButton from "@/components/buttons/TransparentButton";
import TextInput from "@/components/inputs/TextInput";
import { RegistrationApi } from "@/office/auth/registration-api";
import { LOAD_USER_DATA } from "@/store/action-types";
import { mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { helpers, minLength, required } from "@vuelidate/validators";
export default {
  name: "SignUpOtp",
  components: { TextInput, TransparentButton, PrimaryButton },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data() {
    return {
      otpCode: "",
      vuelidateExternalResults: {
        otpCode: "",
      },
    };
  },
  validations() {
    return {
      otpCode: {
        required: helpers.withMessage("otp_code_required", required),
        minLength: helpers.withMessage("otp_incorrect", minLength(4)),
      },
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  mounted() {
    this.$refs.otpInput.focus();
  },
  methods: {
    async verifyUser() {
      const isValid = await this.v$.$validate();

      if (!isValid) {
        return;
      }

      new RegistrationApi()
        .signUpVerify(this.otpCode, this.user.otpOperationId)
        .then(async (r) => {
          if (r.data.success) {
            await this.$store.dispatch(LOAD_USER_DATA);
            this.$router.push("/");
          }
        })
        .catch((err) => {
          Object.assign(this.vuelidateExternalResults, {
            otpCode: err.data.message,
          });

          setTimeout(() => {
            this.v$.$clearExternalResults();
          }, 3000);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-page {
  &__actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 25px;
  }

  &__action {
    &--half {
      width: calc(50% - 5px);
    }
  }
}
</style>
